export default __webpack_public_path__ + "static/banner-wedding-weird-wonderful-wedding-traditions-from-around-the-world-93b8d1ecab258d22bc7ccc59618f97e9.jpg";